import { ISection, ICalendarDragState } from '../../../interfaces/scheduler_interfaces';
import { UnscheduledSectionServant } from '../../unscheduled_sections/servants/unscheduled_section_servant';
import { CalendarScheduledSectionServant } from './calendar_scheduled_section_servant';
import * as _4 from 'lodash4';

angular
  .module('capability-ng-scheduler')

  .factory('sectionsToCalendarFn', (ngCalendarScheduledSectionServant: CalendarScheduledSectionServant) => {
    return (sections: ISection[]) => ngCalendarScheduledSectionServant.buildCalendarSections(sections);
  })
  .factory('unavailableTimesToCalendarFn', (ngCalendarScheduledSectionServant: CalendarScheduledSectionServant) => {
    return (times: any) => ngCalendarScheduledSectionServant.buildUnavailableTimes(times);
  })
  .factory(
    'calendarPreviewSetOnOver',
    (
      addRawTimesInPreviewModeCommand: any,
      deletePreviewTimesCommand: any,
      ngCalendarScheduledSectionServant: CalendarScheduledSectionServant,
      ngUnscheduledSectionServant: UnscheduledSectionServant
    ) => {
      return (draggableElements: HTMLElement[]) => {
        const target = draggableElements[1];
        if (!target.className.includes('drag-area')) {
          return;
        }

        const sectionTileScope: any = angular.element(_4.first(draggableElements)).scope();
        const selectedSection = sectionTileScope.section;
        const sections = ngCalendarScheduledSectionServant.buildCalendarSections([selectedSection]);
        _4.each(sections, (section) => (section.isPreview = true));
        const isConflicting =
          !_4.isEmpty(selectedSection._availability) &&
          ngUnscheduledSectionServant.isSectionConflicting(selectedSection);
        deletePreviewTimesCommand().then(() => {
          addRawTimesInPreviewModeCommand(sections, isConflicting);
        });
      };
    }
  )
  .factory(
    'calendarPreviewSetOnDrag',
    (
      addRawTimesInPreviewModeCommand: any,
      saveSelectedUnscheduledSectionCommand: any,
      deletePreviewTimesCommand: any,
      calendarPreviewDragState: any,
      ngCalendarScheduledSectionServant: CalendarScheduledSectionServant,
      ngUnscheduledSectionServant: UnscheduledSectionServant
    ) => {
      return (draggableElements: HTMLElement[]) => {
        calendarPreviewDragState.setDragging();
        const sectionTileScope: any = angular.element(_4.first(draggableElements)).scope();
        const selectedSection = sectionTileScope.section;
        const sections = ngCalendarScheduledSectionServant.buildCalendarSections([selectedSection]);

        // Remove invalid times
        _4.remove(sections, (section) => section.day_of_week !== 8 && section.to_tm === '00:00:00');

        saveSelectedUnscheduledSectionCommand(selectedSection);
        _4.each(sections, (section) => (section.isPreview = true));
        const isConflicting =
          !_4.isEmpty(selectedSection._availability) &&
          ngUnscheduledSectionServant.isSectionConflicting(selectedSection);
        deletePreviewTimesCommand().then(() => {
          addRawTimesInPreviewModeCommand(sections, isConflicting);
        });
      };
    }
  )
  .factory(
    'calendarPreviewDragEnd',
    (deletePreviewTimesCommand: any, calendarPreviewDragState: any, removeSelectedUnscheduledSectionCommand: any) => {
      return () => {
        calendarPreviewDragState.unsetDragging();
        deletePreviewTimesCommand();
        removeSelectedUnscheduledSectionCommand();
      };
    }
  )
  .factory(
    'calendarPreviewSetSections',
    (
      addRawTimesInPreviewModeCommand: any,
      deletePreviewTimesCommand: any,
      ngCalendarScheduledSectionServant: CalendarScheduledSectionServant,
      ngUnscheduledSectionServant: UnscheduledSectionServant,
      saveSelectedUnscheduledSectionCommand: any
    ) => {
      return (sections: ISection) => {
        const sectionsCalendarFormat = ngCalendarScheduledSectionServant.buildCalendarSections([sections]);

        // Remove any invalid times
        _4.remove(sectionsCalendarFormat, (section) => section.day_of_week !== 8 && section.to_tm === '00:00:00');

        _4.each(sectionsCalendarFormat, (section) => (section.isPreview = true));
        saveSelectedUnscheduledSectionCommand(sections);
        const isConflicting =
          !_4.isEmpty(sections._availability) && ngUnscheduledSectionServant.isSectionConflicting(sections);
        deletePreviewTimesCommand().then(() => {
          addRawTimesInPreviewModeCommand(sectionsCalendarFormat, isConflicting);
        });
      };
    }
  )
  .factory(
    'calendarPreviewRemoveSections',
    (deletePreviewTimesCommand: any, calendarPreviewDragState: any, removeSelectedUnscheduledSectionCommand: any) => {
      return () => {
        if (!calendarPreviewDragState.isDragging()) {
          deletePreviewTimesCommand();
          removeSelectedUnscheduledSectionCommand();
        }
      };
    }
  )
  .factory('calendarPreviewDragState', (): ICalendarDragState => {
    let isDragging: boolean = false;
    return {
      setDragging: (draggingState: ICalendarDragState) => (isDragging = true),
      unsetDragging: (draggingState: ICalendarDragState) => (isDragging = false),
      isDragging: () => isDragging
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/calendar/servants/calendar_functions.ts